"use client";

import DiscussionsBox from "components/company/v3/boxes/DiscussionsBox";
import useAmericanIssuer from "components/company/v3/context/hooks/useAmericanIssuer";
import type { CompanyDiscussionsTabEnum } from "components/company/v3/menu/enums";
import { IAssetType, ISecurityCountry } from "types/graphqlTypes";

interface AmericanDiscussionsBoxProps {
  tickerSymbol: string;
  tab: CompanyDiscussionsTabEnum;
  onChangeTab: (tab: CompanyDiscussionsTabEnum) => void;
}

export default function AmericanDiscussionsBox({ tickerSymbol, tab, onChangeTab }: AmericanDiscussionsBoxProps) {
  const issuer = useAmericanIssuer();

  return (
    <DiscussionsBox
      tickerSymbol={tickerSymbol}
      issuerId={issuer._id}
      country={ISecurityCountry.Us}
      assetType={issuer.isREIT ? IAssetType.AmericanReit : IAssetType.AmericanCompany}
      tab={tab}
      onChangeTab={onChangeTab}
    />
  );
}
